import React, {
  useState,
  useEffect,
  useContext,
  createRef,
  useRef
} from 'react';
import './AllForCommentSend.scss';

import { IComponentCommentSend } from '../../component.d';
import { IResult } from '../../global.d';
import MobileCommentSend from './MobileCommentSend';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import { ICommentType } from '../ComponentCommentList/AllForCommentList';
import RootStore from '../../store/RootStore';

export interface ICommentGift {
  id: number;
  name: string;
  image: string;
  price: number;
  real_price: number;
}

export interface ICommentEmotion {
  id: number;
  name: string;
  images: string;
}

export interface ICommentSend extends IComponentCommentSend {
  onSubmit: (option: {
    type: string;
    text: string;
    question: boolean;
    recomment: number;
  }) => PromiseLike<IResult>;
  onFetchGift: () => PromiseLike<ICommentGift[]>;
  onFetchEmotion: () => PromiseLike<ICommentEmotion[]>;
  rootStore?: RootStore;
}

const AllForCommentSend = (props: IComponentCommentSend) => {
  const { rootStore } = props;

  const onFetchGift = () => {
    return rootStore.commentV2Store.fetchGift();
  };

  const onFetchEmotion = () => {
    return rootStore.commentV2Store.fetchEmotion();
  };

  const onSubmit = (e: {
    type: string;
    text: string;
    question: boolean;
    recomment: number;
  }) => {
    let check = true;
    if (e.type == ICommentType.TEXT) {
      check = rootStore.commentV2Store!.checkContent(e.text);
    }

    if (check) {
      return rootStore
        .commentV2Store!.post({
          type: e.question ? 'question' : e.type,
          content: e.text,
          has_reply: 0,
          gallery_id: window.gallery.id,
          video_data: window.pageDetail.video_data
            ? window.pageDetail.video_data
            : '',
          gallery_data: window.dataDetail ? window.dataDetail.id : '',
          reply_id: e.recomment || 0
        })
        .then((res: IResult) => {
          if (res && res.code == 200) {
            rootStore!.uiStore.showToast({
              content: intl.get('Send succeed'),
              time: 1500
            });
          } else {
            rootStore!.uiStore.showToast({
              content: intl.get('Post Comment Error'),
              time: 1500
            });
          }

          return res;
        });
    } else {
      rootStore!.uiStore.showToast({
        content: intl.get('CommentRepeat'),
        time: 1500
      });

      return new Promise<void>((resolve, reject) => {
        resolve();
      });
    }
  };

  const [needToShow, setNeedToShow] = useState(true);

  useEffect(() => {
    const eventHandler = (e: Event) => {
      if (e && e.type == 'custom-commentsend-show') {
        setNeedToShow(true);
      }
      if (e && e.type == 'custom-commentsend-hide') {
        setNeedToShow(false);
      }
    };

    window.addEventListener('custom-commentsend-show', eventHandler);
    window.addEventListener('custom-commentsend-hide', eventHandler);

    return () => {
      window.removeEventListener('custom-commentsend-show', eventHandler);
      window.removeEventListener('custom-commentsend-hide', eventHandler);
    };
  }, []);

  const [refreshKey, setRefreshKey] = useState(1);

  useEffect(() => {
    const { wxuserStore } = rootStore;
    if (wxuserStore && wxuserStore.user && !wxuserStore.user.is_mock) {
      props.rootStore!.commentV2Store.checkblock();
    }

    const imMessageHandler = (e: any) => {
      let { status } = e;
      window.configDetail.block_all = Number(status);
      setRefreshKey(refreshKey + 1);
    };

    props.rootStore!.imStore.addMessageListener(
      'comment_block_all',
      imMessageHandler
    );

    return () => {
      props.rootStore!.imStore.removeMessageListener(
        'comment_block_all',
        imMessageHandler
      );
    };
  }, [refreshKey]);

  return needToShow ? (
    <MobileCommentSend
      {...props}
      onSubmit={onSubmit}
      onFetchGift={onFetchGift}
      onFetchEmotion={onFetchEmotion}
      rootStore={rootStore}
      key={refreshKey}
    />
  ) : null;
};

export default inject('rootStore')(observer(AllForCommentSend));
